import React, { Component } from 'react';
// import footer_logo from "assets/img/footer_logo.png";
import Logo from 'components/FrontEnd/Brand/Logo';
// import MyImage from 'components/Upload/MyImage';
import { Link } from "react-router-dom";
import { hasRole } from 'helper/helperFunctions';
import FooterLogo from '../Brand/FooterLogo';

class Footer extends Component {
  constructor(props) {
        super(props);
        this.state = {
            username: ''
        }
        this.fbLike = this.fbLike.bind(this);
    }

    fbLike(){
      (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.0";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    }

    componentDidMount(){
      this.fbLike();
    }

  render() {
    return (
      
      <>
      <footer className="et-l et-l--footer">
					<div className="et_builder_inner_content et_pb_gutters3">
						<div className="et_pb_section et_pb_section_1_tb_footer et_pb_with_background et_section_regular">
							<div className="et_pb_row et_pb_row_0_tb_footer et_pb_equal_columns">
								<div className="et_pb_column et_pb_column_1_3 et_pb_column_0_tb_footer ds-vertical-align  et_pb_css_mix_blend_mode_passthrough">
									<div className="et_pb_module et_pb_text et_pb_text_0_tb_footer  et_pb_text_align_left et_pb_bg_layout_light">
										<div className="et_pb_text_inner">
											<p style={{textAlign:'center'}}><span style={{color:'#00a7a7'}}><strong>Incentive TripKit</strong></span>
												<br /><span style={{color:'#a5b6bc'}}> 8300 Fairview Rd.</span>
												<br /><span style={{color:'#a5b6bc'}}> Mint Hill, NC</span><span> </span><span style={{color:'#a5b6bc'}}>28227</span></p>
										</div>
									</div>
								</div>
								<div className="et_pb_column et_pb_column_1_3 et_pb_column_1_tb_footer ds-vertical-align  et_pb_css_mix_blend_mode_passthrough">
									<div className="et_pb_module et_pb_image et_pb_image_0_tb_footer"> <span className="et_pb_image_wrap "><img loading="lazy" width="700" height="412" src="https://incentivetripkit.com/wp-content/uploads/logo.png" alt="" title="" className="wp-image-1022" /></span></div>
								</div>
								<div className="et_pb_column et_pb_column_1_3 et_pb_column_2_tb_footer ds-vertical-align  et_pb_css_mix_blend_mode_passthrough et-last-child">
									<div className="et_pb_module et_pb_text et_pb_text_1_tb_footer  et_pb_text_align_left et_pb_bg_layout_light">
										<div className="et_pb_text_inner">
											<p  style={{textAlign:'center'}}><span style={{color:'#00a7a7'}}><strong>Contact Us</strong><br /><span style={{color:'#a5b6bc'}}>(888) 533-7637<br />ext. 207</span></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="et_pb_row et_pb_row_1_tb_footer">
								<div className="et_pb_column et_pb_column_4_4 et_pb_column_3_tb_footer  et_pb_css_mix_blend_mode_passthrough et-last-child">
									<div className="et_pb_module et_pb_text et_pb_text_2_tb_footer  et_pb_text_align_left et_pb_bg_layout_light">
										<div className="et_pb_text_inner">
											<p style={{color:'#00a7a7', textAlign:'center'}}><span ><strong>About Us<br /></strong></span></p>
											<div className="page" title="Page 2">
												<div className="layoutArea">
													<div className="column">
														<p style={{textAlign:'center',color:'#4c6d79'}}>PhotoVision Inc. has been serving America by preserving and creating memories since 1997, specifically the student and senior adult travel market with our Group Travel Videos. We had so many requests for incentive travel, we decided to create the brand, Incentive TripKit! We are now offering it for your travel incentive promotions since 2019.</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="et_pb_row et_pb_row_2_tb_footer et_pb_equal_columns">
								<div className="et_pb_column et_pb_column_4_4 et_pb_column_4_tb_footer ds-vertical-align  et_pb_css_mix_blend_mode_passthrough et-last-child">
									<div className="et_pb_module et_pb_text et_pb_text_3_tb_footer  et_pb_text_align_left et_pb_bg_layout_light">
										<div className="et_pb_text_inner">
											<p style={{textAlign: 'center',paddingBottom:'1rem'}}>
												<span style={{fontSize: 'small'}}>
													<span style={{color: '#a5b6bc'}}>© Copyright Incentive TripKit</span>
												</span>
											</p>
											<p style={{textAlign: 'center'}}>
												<span style={{fontSize: 'small'}}>
													<a href="https://incentivetripkit.com/privacy/" style={{color: '#eb5453'}}>Privacy Policy</a>   
													<span style={{color: 'white'}}>&nbsp; | &nbsp;</span>
													<a href="https://incentivetripkit.com/terms/" style={{color: '#eb5453'}}>Terms &amp; Conditions</a>
													<span style={{color: 'white'}}>&nbsp; | &nbsp;</span>
													<a href="https://itk.incentivetripkit.com/Customer_Testimonials/" style={{color: '#eb5453'}}>Testimonials</a>
												</span>  
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="et_pb_section et_pb_section_3_tb_footer et_pb_with_background et_section_regular">
							<div className="et_pb_row et_pb_row_3_tb_footer">
								<div className="et_pb_column et_pb_column_4_4 et_pb_column_5_tb_footer  et_pb_css_mix_blend_mode_passthrough et-last-child">
									<div className="et_pb_module et_pb_text et_pb_text_4_tb_footer  et_pb_text_align_left et_pb_bg_layout_light">
										<div className="et_pb_text_inner">
											<p style={{textAlign: 'center'}}><span style={{fontSize: 'small'}}>PART OF THE PHOTOVISION FAMILY</span></p>
										</div>
									</div>
								</div>
							</div>
							<div className="et_pb_row et_pb_row_4_tb_footer">
								<div className="et_pb_column et_pb_column_1_4 et_pb_column_6_tb_footer  et_pb_css_mix_blend_mode_passthrough">
									<div className="et_pb_module et_pb_image et_pb_image_1_tb_footer"> <a href="https://www.photovision.com" target="_blank"><span className="et_pb_image_wrap "><img loading="lazy" width="261" height="63" src="https://incentivetripkit.com/wp-content/uploads/Logos-Footer-PhotoVision.png" alt="" title="" className="wp-image-1397" /></span></a></div>
								</div>
								<div className="et_pb_column et_pb_column_1_4 et_pb_column_7_tb_footer  et_pb_css_mix_blend_mode_passthrough">
									<div className="et_pb_module et_pb_image et_pb_image_2_tb_footer"> <a href="https://www.createavideo.com" target="_blank"><span className="et_pb_image_wrap "><img loading="lazy" width="261" height="63" src="https://incentivetripkit.com/wp-content/uploads/Logos-Footer-CAV.png" alt="" title="" className="wp-image-1399" /></span></a></div>
								</div>
								<div className="et_pb_column et_pb_column_1_4 et_pb_column_8_tb_footer  et_pb_css_mix_blend_mode_passthrough">
									<div className="et_pb_module et_pb_image et_pb_image_3_tb_footer"> <a href="https://www.grouptravelvideos.com" target="_blank"><span className="et_pb_image_wrap "><img loading="lazy" width="261" height="63" src="https://incentivetripkit.com/wp-content/uploads/Logos-Footer-GroupTravel.png" alt="" title="" className="wp-image-1401" /></span></a></div>
								</div>
								<div className="et_pb_column et_pb_column_1_4 et_pb_column_9_tb_footer  et_pb_css_mix_blend_mode_passthrough et-last-child">
									<div className="et_pb_module et_pb_image et_pb_image_4_tb_footer"> <a href="https://photomozaix.com" target="_blank"><span className="et_pb_image_wrap "><img loading="lazy" width="261" height="63" src="https://incentivetripkit.com/wp-content/uploads/Logos-Footer-Mozaix.png" alt="" title="" className="wp-image-1403" /></span></a></div>
								</div>
							</div>
						</div>
					</div>
				</footer>
      </>
    );
  }
}
export default Footer;
